import OnboardingComp from "../../component/Onboarding";

const Onboarding = () => {
  return (
    <>
      <OnboardingComp />
    </>
  );
};

export default Onboarding;
